// This mixin contains code that is used for only gas readings
import readings from './readings';

export default {
  mixins: [readings],
  data() {
    return {
      summaryConverterFields: {
        ReadingDate: {
          label: "Date",
          sortable: true,
          class: "text-center"
        },
        Serial: {
          label: "Meter Serial",
          class: "text-center"
        },
        ReadingType: {
          label: "Reading Type",
          class: "text-center"
        },
        MeterReading: {
          label: "Reading",
          class: "text-center"
        },
        ConverterUncorrectedReading: {
          label: "Uncorrected Reading",
          class: "text-center"
        },
        ConverterCorrectedReading: {
          label: "Corrected Reading",
          class: "text-center"
        },
        AssociatedInvoices: {
          label: "Billing",
          class: "text-center"
        }
      },
      summaryFields: {
        ReadingDate: {
          label: "Date",
          sortable: true,
          class: "text-center"
        },
        Serial: {
          label: "Meter Serial",
          class: "text-center"
        },
        ReadingType: {
          label: "Reading Type",
          class: "text-center"
        },
        MeterReading: {
          label: "Reading",
          class: "text-center"
        },
        AssociatedInvoices: {
          label: "Billing",
          class: "text-center"
        }
      }
    };
  },
  computed: {
    converter() {
      if (this.meters) {
        if (this.currentMeter) {
          return this.$_.has(this.currentMeter, "ConverterSerial");
        }
      }
    },
  },
  methods: {
    meterBySerial(serial) {
      return this.$_.findWhere(this.meters, {
        Serial: serial
      });
    },
    isBillable(event, item) {
      this.$http
        .put(
          "https://" +
          this.$config.honeycomb.readingsbot.gas.domain +
          "/api/v1/readings/" +
          item.SharedId,
          {
            SharedId: item.SharedId,
            DoNotBill: !item.DoNotBill
          },
          {
            withCredentials: true
          }
        )
        .then(() => {
          this.$store.dispatch("refreshReadings");
        });
    }
  }
}